'use client'

import { FC } from 'react'

import CaseStudyChallenge from '@/sections/CaseStudyChallenge'

const LogixboardChallenge: FC<{}> = () => {
    return (
        <CaseStudyChallenge
            paragraph={
                <>
                    Regulation, investors, and consumers are demanding greener freight. Since
                    Logixboard customers are typically Freight Forwarders based in the UK, US,
                    Australia, and New Zealand they are exposed to the green transition.
                    <br />
                    <br />
                    Unsurprisingly, Logixboard customers were seeing emission requirements appear
                    more frequently in tenders. Failing to meet these requests meant losing revenue;
                    fulfilling these requests meant growing revenue.
                    <br />
                    <br />
                    Committed to propelling its customers forward, demand for emission reporting
                    presented a customer problem that needed fixing. However, Logixboard and its
                    customers are experts in logistics, not emissions. They had a data gap that
                    needed closing — fast.
                </>
            }
            imageSrc={'/images/logixboard-case-study/logixboard-problem.png'}
        />
    )
}

export default LogixboardChallenge
